import { render, staticRenderFns } from "./role-tree.vue?vue&type=template&id=c0f01722&scoped=true"
import script from "./role-tree.vue?vue&type=script&lang=js"
export * from "./role-tree.vue?vue&type=script&lang=js"
import style0 from "./role-tree.vue?vue&type=style&index=0&id=c0f01722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f01722",
  null
  
)

export default component.exports